import { modifyHref } from "@/components/Shared/HeaderNavTabs/utils"

/**
 * Extracts links from an HTML string and modifies the href.
 *
 * @param {string} htmlString - The HTML string to extract links from.
 * @return {Array} An array of link objects with modified href and text.
 */
export function extractLinks(htmlString) {
  const linkRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"(?:[^>]*)>(.*?)<\/a>/g
  const links = []
  let match

  while ((match = linkRegex.exec(htmlString)) !== null) {
    links.push({
      component: "a",
      href: modifyHref(match[1].replace("/link", "/modified/link")),
      text: match[2] || "", // Handle missing text gracefully
      trackingAttributes: {
        "data-datalayer-id": "kds-element-navigation",
        "data-datalayer-data": JSON.stringify({
          clickInternalLinks: "true",
          eventAction: `my account:${match[2]?.toLowerCase()}`,
          eventName: `my account:${match[2]?.toLowerCase()}`,
          eventMsg: "n/a",
          eventStatus: "n/a",
          eventType: "global header",
          internalLinkName: match[2]?.toLowerCase(),
          internalLinkPosition: `global header:${match[2]?.toLowerCase()}`,
          internalLinkType: "global header:navigation",
          internalLinkURL:
            match[1] && typeof window !== "undefined"
              ? `${window.location.origin}${match[1]
                  ?.split(process.env.NEXT_PUBLIC_INTERNALLINKPATH)
                  .join("")
                  .replace(".html", "")}`
              : "n/a",
          internalLinkZoneName: "global header",
        }),
      },
    })
  }

  return links
}

/**
 * Returns the cart badge CTA object if the cartLandingPagePath exists and canadaCheck is false, otherwise undefined.
 *
 * @param {string} cartLandingPagePath - The cart landing page URL.
 * @param {number} cartCount - The number of items in the cart.
 * @param {boolean} canadaCheck - If true, the cart icon should not be shown.
 * @return {CartBadgeCTA|undefined} The cart badge CTA object or undefined.
 */
export function getCartBadgeCTA(
  cartLandingPagePath = "",
  cartCount = 0,
  canadaCheck = false
) {
  if (canadaCheck) return null
  return {
    href: cartLandingPagePath,
    digit: cartCount > 0 && cartCount < 999 ? cartCount : null,
    trackingAttributes: {
      "data-datalayer-id": "kds-element-navigation",
      "data-datalayer-data": JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "cart icon",
        eventMsg: "n/a",
        eventName: "cart icon",
        eventStatus: "n/a",
        eventType: "global header",
        internalLinkName: "cart icon",
        internalLinkPosition: "global header",
        internalLinkType: "global header:navigation",
        internalLinkURL: cartLandingPagePath,
        internalLinkZoneName: "global header",
      }),
    },
  }
}
